import { Capacitor } from '@capacitor/core';

/**
 * Platform detection utilities for handling Capacitor vs web contexts
 */

/**
 * Check if the app is running in a Capacitor native context
 * @returns {boolean} True if running in Capacitor (iOS/Android)
 */
export const isCapacitor = () => {
  return Capacitor.isNativePlatform();
};

/**
 * Check if the app is running in a web browser context
 * @returns {boolean} True if running in a web browser
 */
export const isWeb = () => {
  return Capacitor.getPlatform() === 'web';
};

/**
 * Check if the app is running on Android
 * @returns {boolean} True if running on Android
 */
export const isAndroid = () => {
  return Capacitor.getPlatform() === 'android';
};

/**
 * Check if the app is running on iOS
 * @returns {boolean} True if running on iOS
 */
export const isIOS = () => {
  return Capacitor.getPlatform() === 'ios';
};

/**
 * Get the current platform name
 * @returns {string} Platform name ('web', 'android', 'ios')
 */
export const getPlatform = () => {
  return Capacitor.getPlatform();
};

/**
 * Check if running on mobile (Android or iOS)
 * @returns {boolean} True if running on mobile
 */
export const isMobile = () => {
  return isAndroid() || isIOS();
};

/**
 * Platform-specific configuration
 */
export const PlatformConfig = {
  // Whether to use static maps instead of interactive maps
  useStaticMaps: isMobile(),
  
  // Whether to use Capacitor geolocation
  useCapacitorGeolocation: isCapacitor(),
  
  // Whether to show install prompts
  showInstallPrompts: isWeb(),
  
  // Default map dimensions for mobile
  mobileMapSize: '400x300',
  
  // Default map dimensions for web
  webMapSize: '600x400'
};

/**
 * Get appropriate map size based on platform
 * @param {string} customSize - Custom size override
 * @returns {string} Map size string (e.g., '400x300')
 */
export const getMapSize = (customSize) => {
  if (customSize) return customSize;
  return isMobile() ? PlatformConfig.mobileMapSize : PlatformConfig.webMapSize;
};